// extracted by mini-css-extract-plugin
module.exports = {"read-more":"RelatedInsightsCard_read-more__KisD5","max-4-lines":"RelatedInsightsCard_max-4-lines__KEXcb"};